import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { usePaymentTerminalListLazyQuery } from "@ticketingplatform/api/dist/paymentTerminal";
import useAutoComplete from "hooks/useAutoComplete";
import { useCallback } from "react";
import { PaymentTerminal } from "@ticketingplatform/api/dist/paymentTerminal/__generated__/PaymentTerminal";
import type { GetOptionLabel } from "react-select";
import { useVenueContext } from "contexts/VenueContext";

import { UsePaymentTerminalSelect } from "./types";

export const usePaymentTerminalSelect: UsePaymentTerminalSelect = (props) => {
  const { venue } = useVenueContext();
  const [fetchPaymentTerminals] = usePaymentTerminalListLazyQuery();

  return useAutoComplete<PaymentTerminal, false>({
    ...props,
    defaultOptions: true,
    getOptionLabel: useCallback<GetOptionLabel<PaymentTerminal>>(
      ({ name }) => name,
      []
    ),
    loadOptions: useCallback(
      async (search: string) => {
        const { data } = await fetchPaymentTerminals({
          variables: {
            orderBy: [{ name: SortDirection.asc }],
            take: 10,
            filters: {
              ...(venue
                ? {
                    venueId: {
                      equals: venue.id,
                    },
                  }
                : undefined),
              ...(search
                ? {
                    name: {
                      contains: search,
                      mode: QueryMode.insensitive,
                    },
                  }
                : undefined),
            },
          },
        });

        return data?.paymentTerminals?.nodes ?? [];
      },
      [fetchPaymentTerminals, venue]
    ),
  });
};
